import {
  GraduationCap, Gamepad2, CloudSun, Map, Camera, Building2, Flag, Cpu, Scale,
  ShieldCheck, ClipboardList, HeartHandshake, Rocket, BadgeCheck, Plane, Target, Trophy,
} from "lucide-react";

// Central lucide icon registry so backend can reference icons by name.
export const ICONS = {
  GraduationCap, Gamepad2, CloudSun, Map, Camera, Building2, Flag, Cpu, Scale,
  ShieldCheck, ClipboardList, HeartHandshake, Rocket, BadgeCheck, Plane, Target, Trophy,
};

export const getIcon = (name) => ICONS[name] || Rocket;
